import { DashboardhareButton, DashboardhSmallButton, Icon } from 'bd-web-components'
import {
  TextTableCategory,
  TextLinkTableCategory,
} from './table-modeling-style'
import { SECONDARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'

export interface IRenderProps<rowType> {
  value: string
  row: rowType
  index: number
}

export const calcPercent = (totalSize: number, percente: number) => {
  if (percente === 100) return totalSize
  if (percente === 0) return 0
  return totalSize * Number(`0.${percente}`)
}
export const financialCloseCreditAndDebit = (isMobile: boolean) => {
  const componentWidth = isMobile ? 345 : 642
  return [
    {
      title: 'Categoria',
      key: 'description',
      dataIndex: 'description',
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
      width: calcPercent(componentWidth - 32, 50),
    },
    {
      title: 'Valor',
      key: 'formatedValue',
      dataIndex: 'formatedValue',
      width: calcPercent(componentWidth - 32, 50),
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
  ]
}

export const accessAndSalesColumns = (isMobile: boolean) => {
  const componentWidth = isMobile ? 345 : 642
  return [
  {
    title: '1',
    key: 'origin',
    dataIndex: 'origin',
    render: ({ value }: any) => {
      return (
        <div
          style={{
            paddingBottom: '8px',
            width: '100%'
          }}
        >
          <span>{value}</span>
        </div>
      )
    },
    width: calcPercent(componentWidth - 32, 50),
    borderBottom: true,
    removeBorderRight: true
  },
  {
    title: '1',
    key: 'value',
    dataIndex: 'value',
    width: calcPercent(componentWidth - 32, 50),
    right: true,
    removeBorderRight: true,
    borderBottom: true,
    render: ({ row, value }: any) => {
      const control = row.origin === 'Estoque' && value === null
      return (
        <div
          style={{
            marginTop: '0px',
            paddingBottom: '8px',
            width: '100%'
          }}
        >
          {control && (
            <span>
              {' '}
              <Icon
                width={20}
                height={20}
                iconName={'infinity'}
                fill={'black'}
                classes={'rightArrow-carousel-control'}
              />
            </span>
          )}
          {!control && <span>{value}</span>}
        </div>
      )
    }
  }
  ]
}
export const sentCourtesyColumns = (isMobile: boolean) => {
  const componentWidth = isMobile ? 345 : 642

  return [
    {
      title: 'Origem',
      key: 'origin',
      dataIndex: 'origin',
      render: ({ value }: IRenderProps<any>) => {
        return (
          <div
            style={{
              paddingBottom: '8px',
              width: '100%'
            }}
          >
            <span>{value}</span>
          </div>
        )
      },
      width: calcPercent(componentWidth - 32, 50),
      borderBottom: true,
      removeBorderRight: true
    },
    {
      title: 'Info',
      key: 'value',
      dataIndex: 'value',
      width: calcPercent(componentWidth - 32, 50),
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      render: ({ value, row }: IRenderProps<any>) => {
        if (row.origin === 'Voucher') {
          return (
            <div
              style={{
                marginTop: '0px',
                paddingBottom: '8px',
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}
            >
              <DashboardhareButton
                isMobile={isMobile}
                link={value}
                label="Voucher"
                prefixText={'Olá, segure seu ingresso da Bilheteria Digital!'}
              />
            </div>
          )
        }
        return (
          <div
            style={{
              marginTop: '0px',
              paddingBottom: '8px',
              width: '100%'
            }}
          >
            <span>{value}</span>
          </div>
        )
      }
    }
  ]






}

export const financialResume = (isMobile: boolean) => {
  const componentWidth = isMobile ? 345 : 642
  return [
    {
      title: 'Categoria',
      key: 'description',
      dataIndex: 'description',
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
      width: calcPercent(componentWidth - 32, 50),
    },
    {
      title: 'Valor',
      key: 'formatedValue',
      dataIndex: 'formatedValue',
      width: calcPercent(componentWidth - 32, 50),
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
  ]
}

export const financialResumeTransactions = () => {
  return [
    {
      title: 'Data',
      key: 'date',
      dataIndex: 'date',
      width: 100,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Evento',
      key: 'event_name',
      dataIndex: 'event_name',
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
      width: 200,
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 100,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Titular',
      key: 'receiver',
      dataIndex: 'receiver',
      width: 150,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Banco',
      key: 'bank_name',
      dataIndex: 'bank_name',
      width: 100,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Identificador',
      key: 'identifier',
      dataIndex: 'identifier',
      width: 150,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Descrição',
      key: 'description',
      dataIndex: 'description',
      width: 150,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Valor',
      key: 'value',
      dataIndex: 'value',
      width: 100,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Comprovante',
      key: 'receipt_url',
      dataIndex: 'receipt_url',
      width: 130,
      render: ({ value }: any) => {
        return (
          <a style={{ all: 'unset' }} href={value} download>
            {value !== null && (
              <DashboardhSmallButton
                color="#fff"
                background={SECONDARY_BLUE_01}
                height="36px"
                maxWidth="100%"
                variant="contained"
                width="120px"
              >
                <span className="button__submit_code">{'Baixar'}</span>
              </DashboardhSmallButton>
            )}
          </a>
        )
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
  ]
}

export const sentCourtesiesList = () => {
  return [
    {
      title: 'Voucher',
      key: 'voucher',
      dataIndex: 'voucher',
      width: 80,
      render: ({ value }: any) => {
        return (
          <TextLinkTableCategory target="_blank" href={value}>
            VOUCHER
          </TextLinkTableCategory>
        )
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Data',
      key: 'courtesy_day',
      dataIndex: 'courtesy_day',
      width: 80,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Hora',
      key: 'courtesy_time',
      dataIndex: 'courtesy_time',
      width: 50,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },

    {
      title: 'Nome',
      key: 'name',
      dataIndex: 'name',
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
      width: 200,
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      width: 200,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'CPF',
      key: 'cpf',
      dataIndex: 'cpf',
      width: 140,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },
    {
      title: 'Pedido',
      key: 'id',
      dataIndex: 'id',
      width: 100,
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
    },
  ]
}

export const ticketAccessLevel = (isMobile: boolean) => {
  const componentWidth = isMobile ? 345 : 642
  return [
    {
      title: 'Setor',
      key: 'description',
      dataIndex: 'description',
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: false,
      removeBorderRight: true,
      borderBottom: true,
      width: calcPercent(componentWidth - 32, 50),
    },
    {
      title: 'Valor',
      key: 'formatedValue',
      dataIndex: 'formatedValue',
      width: calcPercent(componentWidth - 32, 50),
      render: ({ value }: any) => {
        return <TextTableCategory>{value}</TextTableCategory>
      },
      right: true,
      removeBorderRight: true,
      borderBottom: true,
    },
  ]
}


// formatedValue